import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Grid, Box } from '@material-ui/core';
import queryString from 'query-string';
import { localeMoment as moment } from '../../components/common/moment';
import { withStyles } from '@material-ui/core/styles';
import PageHeader from '../../components/common/PageHeader';
import { ScoreCardPanel } from '../../components/Account';
import { AccountDetails, AccountList } from '../../components/Dashboard';
import { accountLists, benefitsList } from 'enlm_ui_common';
import { clearMesage } from '../Layouts/actions';
import Loader from '../../components/Loader';
import { isEqual, get, isEmpty, findIndex } from '../../utils/lodash';
import feature from '../../utils/feature';
import { getNpsRatings } from '../EinDashboard/actions';
import { npsScoreNumber } from '../../components/NpsDashboard/helper';
import { IndustryNews2 } from '../../components/Dashboard';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  accountWrapper: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
    gridColumnGap: theme.spacing(4.5),
    gridRowGap: theme.spacing(2.5),
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      display: 'block'
    }
  }
});

class index extends Component {
  accountListsData = accountLists;
  benefitsListData = benefitsList;
  state = {
    isNpsUpdated: false
  };

  componentDidMount() {
    this.props.clearMesage();
  }

  componentDidUpdate() {
    const { featureList } = this.props;
    const hasEinDashboard = !isEmpty(featureList) ? feature.isFeatureEnabled('EIN_DASHBOARD') : false;
    if (!this.state.isNpsUpdated && !isEmpty(featureList)) {
      if (hasEinDashboard) {
        this.props.getNpsRatings();
        this.setState({ isNpsUpdated: true });
      } else {
        this.setState({ isNpsUpdated: true });
      }
    }
  }

  getNpsScore = () => {
    const { ratings } = this.props;
    const { ratingsList = [] } = ratings;
    const zeroToTenRatings = {
      zeroRatingsCount: get(ratingsList, '0', 0),
      oneRatingsCount: get(ratingsList, '1', 0),
      twoRatingsCount: get(ratingsList, '2', 0),
      threeRatingsCount: get(ratingsList, '3', 0),
      fourRatingsCount: get(ratingsList, '4', 0),
      fiveRatingsCount: get(ratingsList, '5', 0),
      sixRatingsCount: get(ratingsList, '6', 0),
      sevenRatingsCount: get(ratingsList, '7', 0),
      eightRatingsCount: get(ratingsList, '8', 0),
      nineRatingsCount: get(ratingsList, '9', 0),
      tenRatingsCount: get(ratingsList, '10', 0)
    };
    return npsScoreNumber(zeroToTenRatings, ratingsList);
  };

  renderAccountList = (accountDetailsProps, accountTitle) => {
    const { classes } = this.props;
    const accountList = this.accountListsData.find(account => account.title === accountTitle);
    const { title, list } = accountList;
    return (
      <Box className={classes.scoreCardBody}>
        {list.map((account, index) => (
          <AccountList key={index} accountList={account} title={title} {...accountDetailsProps} />
        ))}
      </Box>
    );
  };

  renderItkComponent = (page, accountDetailsProps) => {
    let itkComponent = null;
    switch (page) {
      case 'account':
        itkComponent = this.renderAccountList(accountDetailsProps, 'account_information');
        break;
      case 'services':
        itkComponent = this.renderAccountList(accountDetailsProps, 'services');
        break;
      case 'news':
        itkComponent = <IndustryNews2 />;
        break;
      default:
        itkComponent = <Fragment />;
        break;
    }
    return itkComponent;
  };

  render() {
    const {
      classes,
      companyId,
      companyInfo,
      company,
      currentlySending,
      accountData,
      accountLoading,
      belongsToAus,
      enlightenManagerToken,
      belongsToUs,
      countryCode,
      companyState,
      einOptIn,
      featureList,
      installingSince,
      sitesCount,
      storagesCount,
      microinvertersCount,
      companyTier,
      ensembleTraining,
      solarInstallCertification,
      location,
      viewOnlyAccess,
      einOptOut,
      locale
    } = this.props;
    const { platform = '', page = '' } = queryString.parse(location.search);

    if (accountLoading || currentlySending) return <Loader loading={accountLoading || currentlySending} />;
    const { nps, ein_opt_in, ein_opt_out } = companyInfo;
    const hasEinDashboard = !isEmpty(featureList) ? feature.isFeatureEnabled('EIN_DASHBOARD') : false;
    const npsScore = this.state.isNpsUpdated ? (hasEinDashboard ? this.getNpsScore() : nps) : '';
    const scoreCardDetails = {
      tier: companyTier,
      installingSince: installingSince && moment(installingSince).format('DD-MMM-YY'),
      ensembleCertification: ensembleTraining ? 'yes' : 'no',
      npsScore,
      sitesCount,
      invertersCount: microinvertersCount,
      storagesCount,
      solarInstallCertification: solarInstallCertification ? 'yes' : 'no',
      belongsToUs,
      belongsToAus
    };

    const country = get(company, 'address.country') || countryCode || '';
    const state = get(company, 'address.state') || companyState || '';
    const leadOptIn = feature.isFeatureEnabled('LEAD_OPT_IN') || false;
    const abLreEnabled = feature.isFeatureEnabled('LRE_ENABLED') || false;
    const abPermitEnabled = feature.isFeatureEnabled('PERMIT_ENABLED') || false;
    const abSgipEnabled = feature.isFeatureEnabled('INCENTIVE_PROGRAM') || false;
    const abEinMerchandise = feature.isFeatureEnabled('EIN_MERCHANDISE') || false;
    const generatorTokensEnabled =
      (window.build_environment !== 'preprod') && (accountData?.is_installer_account || accountData?.is_distributor) ?
        feature.isFeatureEnabled('GENERATOR_TOKENS') || false :
        false;
    const dataPlanExtensionEnabled =
      (window.build_environment !== 'preprod') && (accountData?.is_installer_account || accountData?.is_distributor) ?
        feature.isFeatureEnabled('CELLMODEM_DATA_PLAN_EXTENSION') || false :
        false;
    const isAuthorizedSubcontractor = feature.isFeatureEnabled('AUTHORIZED_SUBCONTRACTOR') || false;
    const abBOMEnabled = feature.isFeatureEnabled('BOM_CALCULATOR') || false;
    const hasTier = !!(companyInfo && companyInfo.tier && companyInfo.tier.name);
    const isUSA = country && country.toLowerCase() === 'us';
    const benefitsIndex = findIndex(this.accountListsData, account => account.key === 'benefits');
    if (isUSA && benefitsIndex < 0) {
      this.accountListsData.splice(1, 0, this.benefitsListData);
    }
    const isUser = accountData && accountData.roles && isEqual(accountData.roles, []) === true;
    const isDemo =
      (accountData && accountData.roles && accountData.roles.includes('demo')) ||
      (viewOnlyAccess && !accountData.login_as);
    if (isUser) {
      const companyIndex = findIndex(this.accountListsData, account => account.key === 'account_information');
      companyIndex > -1 && this.accountListsData.splice(companyIndex, 1);
    }
    const accountDetailsProps = {
      companyId,
      leadOptIn,
      abLreEnabled,
      abSgipEnabled,
      abPermitEnabled,
      abEinMerchandise,
      state,
      enlightenManagerToken,
      generatorTokensEnabled,
      isAuthorizedSubcontractor,
      abBOMEnabled,
      einOptIn: ein_opt_in || einOptIn,
      einOptOut: ein_opt_out || einOptOut,
      hasTier,
      viewOnlyAccess,
      companyInfo,
      accountData,
      featureList,
      countryCode,
      locale,
      dataPlanExtensionEnabled
    };
    if (platform === 'itk' && !isEmpty(page)) {
      return <Fragment>{this.renderItkComponent(page, accountDetailsProps)}</Fragment>;
    }
    return (
      <div className={classes.root}>
        <PageHeader text="Account" />
        {(ein_opt_in || einOptIn) && <ScoreCardPanel {...scoreCardDetails} npsScoreUpdated={this.state.isNpsUpdated} />}
        {!isDemo && (
          <Grid className={classes.accountWrapper}>
            {this.accountListsData.map(
              (accountList, index) =>
                accountList.title !== 'benefits' ? (
                  <AccountDetails
                    key={index}
                    accountList={accountList}
                    {...accountDetailsProps}
                  />
                ) : (
                  ''
                )
            )}
          </Grid>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  clearMesage: () => dispatch(clearMesage()),
  getNpsRatings: () => dispatch(getNpsRatings())
});

const mapStateToProps = state => ({
  companyId: state.appReducer.companyId,
  company: state.appReducer.company,
  companyInfo: state.appReducer.companyInfo,
  currentlySending: state.appReducer.currentlySending,
  accountLoading: state.accountReducer.currentlySending,
  accountData: state.accountReducer.accountDetail,
  belongsToAus: state.appReducer.belongsToAus,
  enlightenManagerToken: state.appReducer.enlightenManagerToken,
  belongsToUs: state.appReducer.belongsToUs,
  countryCode: state.appReducer.countryCode,
  companyState: state.appReducer.companyState,
  einOptIn: state.appReducer.einOptIn,
  einOptOut: state.appReducer.einOptOut,
  ratings: state.einDashboardReducer.ratings,
  featureList: state.appReducer.featureList,
  installingSince: state.appReducer.installingSince,
  sitesCount: state.appReducer.sitesCount,
  storagesCount: state.appReducer.storagesCount,
  microinvertersCount: state.appReducer.microinvertersCount,
  companyTier: state.appReducer.companyTier,
  ensembleTraining: state.appReducer.ensembleTraining,
  solarInstallCertification: state.appReducer.solarInstallCertification,
  viewOnlyAccess: state.accountReducer.viewOnlyAccess,
  locale: state.accountReducer.locale
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(index));
